module.exports = __webpack_public_path__ + "img/cszq_bg.1f9cd9d2.jpg";